<form [formGroup]="this.appForm[formName]" autocomplete="off">
  <div *ngFor="let fieldConfig of formConfig; let i = index" [attr.data-index]="i">
    <div [hidden]="fieldConfig.hidden" class="form-group"
    *ngIf="(fieldConfig.elementType !== 'formGroup') && (fieldConfig.elementType !== 'checkbox') && (fieldConfig.elementType !== 'radio') &&
    (fieldConfig.elementType !=='dropdown') && (fieldConfig.elementType !=='content') && (fieldConfig.elementType !=='infolink')">
    <label class="col-sm-12 col-md-7" [attr.for]="formName +'-serviceconfig' + i"
      [ngClass]="{'error-field': formErrors[fieldConfig.formControlName]}">
      <span class="text-label-input display-inline-label">{{fieldConfig.label}}</span>
      <div class="tooltip-input display-inline-label" [ngClass]="{'tooltip-input':(fieldConfig.toolTipText !== '')}">
        <i *ngIf="(fieldConfig.toolTipText !== '')" class="icon-flat-faq tooltip-icon" tabindex="0"
          aria-describedby="inputhelp" (keypress)="toggleTooltip($event)" (click)="toggleTooltip($event)"
          aria-label="Help"></i>
        <div *ngIf="(fieldConfig.toolTipText !== '')" role="tooltip" class="helper-text" id="inputhelp">
          {{fieldConfig.toolTipText}}</div>
        </div>
    </label>
    <div class="col-sm-12 col-md-7" *ngIf="formName!=='loginform'">
        <input id="{{formName +'-serviceconfig' + i}}" type={{fieldConfig.elementType}} class="form-control"
          [attr.disabled]="fieldConfig.disabled ? '' : null" placeholder={{fieldConfig.placeHolder}} [ctnmask]="(fieldConfig.ctnmask==='true')"
          [numberOnly]="(fieldConfig.numberOnly==='true')" [noNumbers]="(fieldConfig.noNumbers==='true')"
          [class.text-error]="formErrors[fieldConfig.formControlName]" formControlName={{fieldConfig.formControlName}}
          [maxLength]="(!fieldConfig.validation.maxLength || fieldConfig.validation.maxLength==='') ? 524288 : fieldConfig.validation.maxLength" />
    </div>
    <div class="col-sm-12 col-md-7" *ngIf="formName==='loginform'">
      <input id="{{formName +'-serviceconfig' + i}}" type={{fieldConfig.elementType}} class="form-control"
        [attr.disabled]="fieldConfig.disabled ? '' : null" placeholder={{fieldConfig.placeHolder}}
        [class.text-error]="formErrors[fieldConfig.formControlName]" formControlName={{fieldConfig.formControlName}}
        [maxLength]="(!fieldConfig.validation.maxLength || fieldConfig.validation.maxLength==='') ? 524288 : fieldConfig.validation.maxLength" />
  </div>
    <div *ngIf="formErrors[fieldConfig.formControlName]" class="text-danger marleft-20"
      [innerHTML]="this.formErrors[fieldConfig.formControlName]">
    </div>
  </div>

    <div [innerHTML]="fieldConfig.content" *ngIf="(fieldConfig.elementType === 'content')">
    </div>

    <div class="link-content" *ngIf="(fieldConfig.elementType === 'infolink')">
      <a href="javascript:void(0)" (click)="showFormLinkInfoModal($event,fieldConfig.content)">
        {{fieldConfig.label}}</a>
      <div *ngIf='showFormLinkInfo'>
        <app-modal [showModal]="showFormLinkInfo">
          <app-confirm-modal [modalPopupObject]='formBuilderPopup' [triggerElement]='eventEmit'
            (modalOutput)="closeFormLinkInfoModal()">
          </app-confirm-modal>
        </app-modal>
      </div>
    </div>


    <div *ngIf="(fieldConfig.elementType === 'checkbox')">
      <fieldset class="fieldset">
        <legend class="offscreen">Checkbox fieldset section</legend>
        <div class="form-group content-margin">
          <div *ngIf="(fieldConfig.formControlName !== 'termsConditions')">
            <label [attr.for]="formName +'-serviceconfig' + i" class="checkbox">
              <input type="checkbox" formControlName={{fieldConfig.formControlName}}
                id="{{formName +'-serviceconfig' + i}}" value={{fieldConfig.initialValue}}>
              <i class="skin"></i>
              <span>{{fieldConfig.label}}</span>
            </label>
            <button *ngIf="(fieldConfig.toolTipText !== '')" class="tooltip-container">
              <i class="icon-flat-faq tooltip-icon" tabindex="0" aria-describedby="inputhelp" aria-label="Help"></i>
              <div role="tooltip" class="helper-text" id="inputhelp">{{fieldConfig.toolTipText}}</div>
            </button>
          </div>
          <div *ngIf="(fieldConfig.formControlName === 'termsConditions')">
            <label [attr.for]="formName +'-serviceconfig' + i" class="checkbox">
              <input type="checkbox" disabled *ngIf="fieldConfig.link.url ?.length === 0"
                formControlName={{fieldConfig.formControlName}} id="{{formName +'-serviceconfig' + i}}"
                value={{fieldConfig.initialValue}}>
              <input type="checkbox" *ngIf="fieldConfig.link.url ?.length > 0"
                formControlName={{fieldConfig.formControlName}} id="{{formName +'-serviceconfig' + i}}"
                value={{fieldConfig.initialValue}}>
              <i class="skin"></i>
              <!--<span *ngIf="fieldConfig.link.url ?.length > 0">I have read and agree to the <a href="javascript:void(0)" (click)="this.termsConditionPopup =  true">-->
              <span *ngIf="fieldConfig.link.url ?.length > 0">I have read and agree to the <a href="javascript:void(0)"
                  (click)="populateModelPopup(fieldConfig.link.text,fieldConfig.link.url,$event)">
                  {{fieldConfig.label}}.</a></span>
              <span *ngIf="fieldConfig.link.url ?.length === 0">I have read and agree to the
                {{fieldConfig.label}}.</span>
            </label>
            <!--<div *ngIf="this.termsConditionPopup">
              <app-terms-content [showModal]="termsConditionPopup" [title]='fieldConfig.link.text' [triggerElement]='eventEmit' [contentUrl]="fieldConfig.link.url" (modalOutput)="this.termsConditionPopup =  false"></app-terms-content>
            </div>-->
          </div>
          <div *ngIf="formErrors[fieldConfig.formControlName]" class="text-danger marleft-20">
            {{this.formErrors[fieldConfig.formControlName] }}
          </div>
        </div>
      </fieldset>
    </div>


    <div class="text-main" *ngIf="(fieldConfig.elementType === 'radio')">
      <fieldset class="fieldset">
        <legend class="offscreen">Radio fieldset</legend>
        <div class="form-group content-margin">
          <label [className]="(fieldConfig.css) ? fieldConfig.css : 'radio'" 
                [attr.for]="formName +'-serviceconfig' + i +'-'+ idx" 
            *ngFor="let entry of fieldConfig.list.listValues; let idx = index">
            <input type="radio" formControlName={{fieldConfig.formControlName}}
              id="{{formName +'-serviceconfig' + i +'-'+ idx}}" value={{entry.value}}>
            <i class="skin"></i>
            <span>{{entry.label}}</span>
            <button *ngIf="(entry.toolTipText && entry.toolTipText !== '')" class="tooltip-container">
              <i class="icon-flat-faq tooltip-icon" tabindex="0" aria-describedby="inputhelp" aria-label="Help"></i>
              <div role="tooltip" class="helper-text" id="{{'radio' + '-toolTip' + '-' + idx}}">{{entry.toolTipText}}</div>
            </button>
          </label>
        </div>
        <div *ngIf="formErrors[fieldConfig.formControlName]" class="text-danger marleft-20">
          {{this.formErrors[fieldConfig.formControlName] }}
        </div>
      </fieldset>
    </div>

    <div class="form-group" *ngIf="(fieldConfig.elementType ==='dropdown')">
      <label class="col-sm-12 col-md-7" [attr.for]="formName +'-serviceconfig' + i"
        [ngClass]="{'error-field': formErrors[fieldConfig.formControlName]}">{{fieldConfig.label}}</label>
      <div class="col-sm-12 col-md-7 field-group">
        <app-dropdown [options]="fieldConfig.list.listValues" [labelId]="formName +'-serviceconfig' + i"
          formControlName={{fieldConfig.formControlName}} [prePopulateValue]="fieldConfig.list.initialValue"
          (selectEmit)="selected($event,fieldConfig.list)" [inputId]="fieldConfig.formControlName"></app-dropdown>
      </div>
      <div *ngIf="formErrors[fieldConfig.formControlName]" class="text-danger marleft-20">
        {{this.formErrors[fieldConfig.formControlName] }}
      </div>
    </div>

    <!--<div class="form-group" *ngIf="(fieldConfig.elementType ==='tooltip')">
      <label class="col-sm-12 col-md-7" [attr.for]="formName +'-serviceconfig' + i" [ngClass]="{'error-field': formErrors[fieldConfig.formControlName]}">{{fieldConfig.label}}</label>
      <div class="col-sm-12 col-md-7">
        <div class="tooltip-input">
          <input id="{{formName +'-serviceconfig' + i}}" type={{fieldConfig.elementType}} class="form-control" placeholder={{fieldConfig.placeHolder}}
            [class.text-error]="formErrors.formControlName" formControlName={{fieldConfig.formControlName}} />
          <i class="icon-flat-faq tooltip-icon" tabindex="0" aria-describedby="inputhelp" (keypress)="toggleTooltip($event)" (click)="toggleTooltip($event)"
            aria-label="Help"></i>
          <div role="tooltip" class="helper-text" id="inputhelp">{{fieldConfig.placeHolder}}</div>
        </div>
      </div>
      <div *ngIf="formErrors[fieldConfig.formControlName]" class="text-danger marleft-20">
        {{this.formErrors[fieldConfig.formControlName] }}
      </div>
    </div> -->

    <section *ngIf="(fieldConfig.elementType === 'formGroup')" [ngClass]="fieldConfig.class">
      <fieldset class="fieldset" *ngIf="fieldConfig.title">
        <legend class="offscreen">{{fieldConfig.title}}</legend>
        <h3 *ngIf="fieldConfig.title">
          {{fieldConfig.title}}
          <button *ngIf="fieldConfig.toolTip" class="tooltip-container">
            <i class="icon-flat-faq tooltip-icon" tabindex="0"
              [attr.aria-describedby]="fieldConfig.fields[0].formControlName" aria-label="Help"></i>
            <div role="tooltip" class="helper-text" id="{{fieldConfig.fields[0].formControlName}}">
              <h5 *ngIf="fieldConfig.toolTipText.heading">{{fieldConfig.toolTipText.heading}}</h5>
              <p *ngIf="fieldConfig.toolTipText.text">{{fieldConfig.toolTipText.text}}</p>
            </div>
          </button>
        </h3>
        <div *ngIf="fieldConfig.subHead">
          <p>{{fieldConfig.subHead}}</p>
        </div>
        <div *ngIf="fieldConfig.description">
          <div *ngIf="apnrestriction == 'false'">
            <p [innerHTML]="fieldConfig.description"></p>
            <p>{{fieldConfig.description2}}<a *ngIf="fieldConfig.link"
                aria-label="Learn more about the network restriction" href="faq"
                target="_blank">{{fieldConfig.link}}</a></p>
          </div>
          <div *ngIf="apnrestriction == 'true'">
            <p>{{fieldConfig.description}}<a *ngIf="fieldConfig.link"
                aria-label="Learn more about the network restriction" href="faq"
                target="_blank">{{fieldConfig.link}}</a></p>
          </div>
        </div>
        <div *ngFor="let field of fieldConfig.fields;">
          <div class="row {{field.formControlName}}" *ngIf="field.elementType == 'onOffSwitch'">
            <div class="col-sm-8 col-md-8 ">
              <label>{{field.label}}</label>
              <button *ngIf="fieldConfig.fields[0].toolTip" class="tooltip-container">
                <i class="icon-flat-faq tooltip-icon" tabindex="0"
                  [attr.aria-describedby]="fieldConfig.fields[0].formControlName"
                  [attr.aria-label]="'Tooltip about the '+field.label+' as '+fieldConfig.toolTipText[field.formControlName].text"></i>
                <div role="tooltip" class="helper-text" id="{{fieldConfig.fields[0].formControlName}}">
                  <h5 *ngIf="fieldConfig.toolTipText[field.formControlName].heading">
                    {{fieldConfig.toolTipText[field.formControlName].heading}}</h5>
                  <p *ngIf="fieldConfig.toolTipText[field.formControlName].text">
                    {{fieldConfig.toolTipText[field.formControlName].text}}</p>
                </div>
              </button>
            </div>

            <div class="col-sm-4 col-md-4 " *ngIf="apnrestriction == 'true'">
              <label for="{{field.formControlName+i}}" class="btn-switch-label">
                <div class="btn-switch">
                  <input #onOffSwitchElement (focus)="onOffSwitchFocus(onOffSwitchElement, 0)"
                    (focusout)="onOffSwitchFocus(onOffSwitchElement, 1)" name="{{field.formControlName}}"
                    formControlName="{{field.formControlName}}" id="{{field.formControlName+i}}" disabled
                    type="checkbox">
                  <div class="switch-overlay">
                    <span class="btn-slider-on">On</span>
                    <span class="switch-handle"></span>
                    <span class="btn-slider-off">Off</span>
                  </div>
                </div>
              </label>
            </div>

            <div class="col-sm-4 col-md-4 " *ngIf="apnrestriction == 'false'">
              <label for="{{field.formControlName+i}}" class="btn-switch-label">
                <div class="btn-switch">
                  <input #onOffSwitchElement [attr.aria-label]="'Switch element about the '+field.label"
                    (focus)="onOffSwitchFocus(onOffSwitchElement, 0)"
                    (focusout)="onOffSwitchFocus(onOffSwitchElement, 1)" name="{{field.formControlName}}"
                    formControlName="{{field.formControlName}}" id="{{field.formControlName+i}}" type="checkbox">
                  <div class="switch-overlay">
                    <span class="btn-slider-on">On</span>
                    <span class="switch-handle"></span>
                    <span class="btn-slider-off">Off</span>
                  </div>
                </div>
              </label>
            </div>
          </div>
          <div role="group" class="check" *ngIf="field.elementType == 'radio'">
            <div *ngFor="let options of field.options;" [ngClass]="field.elementType">
              <label for="{{field.formControlName + options.name}}">
                <input #radioElement [attr.name]="field.formControlName"
                  [attr.aria-label]="options.name+' under '+field.formControlName"
                  formControlName={{field.formControlName}} id="{{field.formControlName + options.name}}"
                  value="{{options.value}}" type="radio" />
                <i class="skin"></i>
                <span>{{options.name}}</span>
              </label>
              <button *ngIf="field.toolTip && options.name !== 'None'" class="tooltip-container">
                <i class="icon-flat-faq tooltip-icon" [attr.tabindex]="radioElement.checked ? 0 : -1"
                  [attr.aria-describedby]="field.formControlName"
                  [attr.aria-label]="'Tooltip about the '+field.formControlName+' '+options.name+' as '+fieldConfig.toolTipText[options.name].text"></i>
                <div role="tooltip" class="helper-text" id="{{field.formControlName}}">
                  <h5 *ngIf="fieldConfig.toolTipText[options.name].heading">
                    {{fieldConfig.toolTipText[options.name].heading}}</h5>
                  <p *ngIf="fieldConfig.toolTipText[options.name].text">{{fieldConfig.toolTipText[options.name].text}}
                  </p>
                </div>
              </button>
            </div>
          </div>

          <div role="group" class="check" *ngIf="field.elementType == 'checkbox'">
            <div *ngFor="let options of field.options;" [ngClass]="field.elementType">
              <label for="{{field.formControlName + options.name}}">
                <input formControlName={{field.formControlName}}
                  [attr.aria-label]="options.name+' under '+fieldConfig.title"
                  id="{{field.formControlName + options.name}}" value="{{options.value}}" type="checkbox" />
                <i class="skin"></i>
                <span>{{options.name}}</span>
              </label>
            </div>
          </div>

          <div *ngIf="formErrors[field.formControlName]" class="text-danger marleft-20">
            {{this.formErrors[field.formControlName] }}
          </div>
        </div>
      </fieldset>
    </section>
  </div>
</form>
